import React from "react";
import { mergeClasses } from "@griffel/react";
import StylesConfig from "../../config/styles-config";

export interface IRadioButtonProps {
  checked?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  id: string;
  label: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
}
/**
 * RadioButtonGroup component
 * @param props The properties for this component
 * @param props.checked Whether the component should be checked or not
 * @param props.disabled Wheter the component should be disabled or not
 * @param props.hidden Whether the component should be visible or not
 * @param props.id Input field ID
 * @param props.label Label rendered after the Radio button
 * @param props.name Input field Name
 * @param props.onClick Function to be called when the component is clicked
 * @param props.value Input field Value
 * @returns A single radio button component
 */
export const RadioButton: React.FC<IRadioButtonProps> = function RadioButton(props) {
  const { useRadioButtonStyles } = StylesConfig.instance;
  const radioButtonStyles = useRadioButtonStyles();

  const {
    checked,
    disabled = false,
    hidden = false,
    id,
    label,
    name = "",
    onChange,
    value,
  } = props;

  if (hidden) return null;

  return (
    <label htmlFor={id} className={radioButtonStyles.buttonContainer}>
      <input
        checked={checked}
        className={radioButtonStyles.button}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />
      <span
        className={
          disabled
            ? mergeClasses(radioButtonStyles.label, radioButtonStyles.disabledLabel)
            : radioButtonStyles.label
        }
      >
        {label}
      </span>
    </label>
  );
};
